import http from "../utils/request";

// 登录
export function LOGIN_AND_AUTH(params) {
  return http.get("/user/loginAndAuth", { params });
}
